import x from "./RecommendedVideos";
export default x;
